"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _IconWithBackground = _interopRequireDefault(require("./IconWithBackground"));
var _Text = _interopRequireDefault(require("../Text"));
var _IconCamera = _interopRequireDefault(require("../../icons/General/IconCamera"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const UploadButton = ({
  css,
  addMore,
  onClick,
  isDragging,
  ...dragProps
}) => (0, _jsxRuntime.jsx)("button", {
  type: "button",
  css: [_styles.uploadButtonStyles.default, addMore ? _styles.uploadButtonStyles.addMore : _styles.uploadButtonStyles.addImage, css && css, process.env.NODE_ENV === "production" ? "" : ";label:UploadButton;"],
  onClick: onClick,
  ...dragProps,
  children: (0, _jsxRuntime.jsxs)("div", {
    children: [(0, _jsxRuntime.jsx)(_IconWithBackground.default, {
      icon: (0, _jsxRuntime.jsx)(_IconCamera.default, {
        color: "none"
      }),
      variant: "imageUpload"
    }), isDragging ? (0, _jsxRuntime.jsx)(_Text.default, {
      semibold: true,
      children: "Slipp her for \xE5 laste opp"
    }) : (0, _jsxRuntime.jsxs)(_Text.default, {
      semibold: true,
      children: ["Legg til ", addMore ? 'flere bilder' : 'bilde']
    })]
  })
});
var _default = exports.default = UploadButton;